import { z } from 'zod';

export const USER_ROLES = {
	god: 0,
	admin: 1,
	cashier: 2,
} as const satisfies Record<string, number>;

export type UserRole = (typeof USER_ROLES)[keyof typeof USER_ROLES];

export const userRolesSchema = z.nativeEnum(USER_ROLES);
